// GENERATED FILE — do not edit by hand.
// Rebuild with: npm run archive:firmware
//
// Every Apollo-main payload that the temple writer is permitted to install.
// This table is the writer's own trust root: it is compiled into the bundle and
// is deliberately independent of the fetched firmware catalog, so a tampered
// index.json cannot widen what may be written to a temple.
//
// hardwareValidated marks images whose case-USB temple transfer has actually
// been exercised on hardware. Pinned-but-unvalidated images are still gated on
// exact hashes; they simply have no transfer evidence behind them yet.

export const TEMPLE_FLASH_TARGETS = Object.freeze([
  Object.freeze({
    imageSha256: "f5562b636a77c260e950da4f872d1e94224159841b9cb6b9c47faab2818aded4",
    mainSha256: "c3dee6cd7ebb06c9142c19314842d7ce8c2e800bfc140630356a2d0684b7f6b7",
    mainBytes: 3838184,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local diagnostic SybilSight/230.25",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.25",
  }),
  Object.freeze({
    imageSha256: "5449127b711fe90902582dd48e113d915420cf6ada3ead7daa75cfa2361ce2a7",
    mainSha256: "74c0e3eaca22f3b336bf144ffd3c1ddcb3cdce6cb1e0ee764f997d86277b60a2",
    mainBytes: 3838048,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local diagnostic SybilSight/230.24",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.24",
  }),
  Object.freeze({
    imageSha256: "df0358e5111ab509072e195d40c3cbd6e011928613fb8b6aaff85c6ef03ae316",
    mainSha256: "d15ae1739269f1d6d1c9f6e8b4027dc0a743319db1bb7f9a27293ac2ad3919e6",
    mainBytes: 3837928,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local diagnostic SybilSight/230.23",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.23",
  }),
  Object.freeze({
    imageSha256: "10f047dab6fe551e29cfe885bf279da5e564331bcd8205a000a376f84bfc79b8",
    mainSha256: "22f7e357690582787975178f78965d8c48f54eabc57cd5c81e8cc85458415894",
    mainBytes: 3837680,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local diagnostic SybilSight/230.22",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.22",
  }),
  Object.freeze({
    imageSha256: "c6ecd1cfc3acb72099cf2faf794d6fa895d5f0c1d70d37df2c2579fd925b927d",
    mainSha256: "94a78d4f28a90796c5ab6257735042974eb54cef8dc4b422ca794937cd4f4967",
    mainBytes: 3837516,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local diagnostic SybilSight/230.21",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.21",
  }),
  Object.freeze({
    imageSha256: "0073690b9a73c26d9297ed1fb790ad37c1554cf8dca757308e26448e292e860c",
    mainSha256: "9277c9a52bbb381fdd0944400ccb4de276954bcb6a9ba57d449b7f957beb6302",
    mainBytes: 3840540,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local diagnostic SybilSight/230.19",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.19",
  }),
  Object.freeze({
    imageSha256: "01d5e44cdf0802cf4d87639c079ddb05280d2b82f44d48dc3c1374e15f60a7ab",
    mainSha256: "cc8f4453f5642925e3841f12fc48c4f1c49cec02891756f0f7955f0ef54f6bc6",
    mainBytes: 3840292,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local experimental SybilSight/230.18",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.18",
  }),
  Object.freeze({
    imageSha256: "1e0dfdb6d012947ea3efa6b0742c2ea5e8093a313e4bebe8b82b7077bc6d8561",
    mainSha256: "7ac1aa03ac54d89698344160a73512672d018069dd6e13bee559e3bff3dd4417",
    mainBytes: 3819500,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local experimental SybilSight/230.17",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.17",
  }),
  Object.freeze({
    imageSha256: "1d45f689eb7d39e5e4fec733bd30966a2659b00e906fc2814d6e22061fcc2c75",
    mainSha256: "217756cc297ff677156a6ca04aa1e964bdf26c20df3ae298e988b29e7d4582af",
    mainBytes: 3813992,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local experimental SybilSight/230.14",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.14",
  }),
  Object.freeze({
    imageSha256: "527336e6c91158148f1c44be498895abcdf66ed8604de896e576e04f9517fbf9",
    mainSha256: "170d2c33acdb550f881572b1eed68c503fc7aff9f558c996b5fb41c0239e8afa",
    mainBytes: 3813772,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local experimental SybilSight/230.13",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.13",
  }),
  Object.freeze({
    imageSha256: "e7fe637d7ee5ce889976ee4f82a1bb9c67a50bd3a33ce98be7c373a8cc546553",
    mainSha256: "0bce60ecbdd906e66d16a5afd069f491c6baacb64dec0ea54c3d149f578e9e35",
    mainBytes: 3813316,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local experimental SybilSight/230.12",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.12",
  }),
  Object.freeze({
    imageSha256: "6349192de1744319ee78a7b85f77664f6cf80f4df9664fa01dd9f59746178da6",
    mainSha256: "30a68208eb89e09621c3b85e55f601c00f4667da95349cb3c98c6ee27082ee87",
    mainBytes: 3813232,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local experimental SybilSight/230.11",
    hardwareValidated: true,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.11",
  }),
  Object.freeze({
    imageSha256: "bbb334bad754826f8d4397505adc23f9177931f46ed7d6192a680a7f59637c48",
    mainSha256: "506796e5acc22a0b6b773ce73243655f1e20c15c4536dd81a36da20f49dab1c9",
    mainBytes: 3813168,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "Local experimental SybilSight/230.10",
    hardwareValidated: false,
    localOnly: true,
    requiredCfwMarker: "SybilSight/230.10",
  }),
  Object.freeze({
    imageSha256: "26b6067665a441b779c47f6b95427b8b4bb5f502aaf527466dadce628aeb00b2",
    mainSha256: "d6d29ec6a6d7d3f7e0abb260c54493e2e5dd0ed978346dc41061ee6522d40fc6",
    mainBytes: 3922636,
    version: "2.3.2.14",
    reportedVersion: "2.3.2.14",
    label: "Stock Even Realities G2 2.3.2.14",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "97dcac92482bfe01b6375b6096f949572261a299a0341489299c1eb6ffae6fbb",
    mainSha256: "e2d010494c09b77d303ea2365cce5f9b53977e88c6a312a743359034f8c01331",
    mainBytes: 3889598,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    baseVersion: "2.3.0.24",
    label: "SybilSight CFW 230.87 (2.3.0.24)",
    hardwareValidated: false,
    requiredCfwMarker: "SybilSight/230.87",
  }),
  Object.freeze({
    imageSha256: "187ccf2bcc5c17a212106e8a376745511e8289c4232b634a7ea94b9bf25a0979",
    mainSha256: "c07813ceaf7ed16502e94406c957eb8cf9d6e8a94ac4ba9bafaefa50ebc9ff46",
    mainBytes: 3758720,
    version: "2.3.0.24",
    reportedVersion: "2.3.0.24",
    label: "Stock Even Realities G2 2.3.0.24",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "927879057685a4147c6ba1fe33e5f3740d3cc48f87141a9039204d94516e65b8",
    mainSha256: "6ff47ca0cf9efa222e4e96bff85a87921a0e2fff657d7b51aab7a1a8da7d847b",
    mainBytes: 3713884,
    version: "2.2.10.10",
    reportedVersion: "2.2.10.10",
    label: "Stock Even Realities G2 2.2.10.10",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "a03fbea9f68a9de6bc271daabb9f3a41c59053d1086622c76a4e990f829cc561",
    mainSha256: "35844c95c6ffe62baca961d396c870225cdc91372f253abaece40c3e99a1c3d2",
    mainBytes: 3697284,
    version: "2.2.9.22",
    reportedVersion: "2.2.9.22",
    label: "Stock Even Realities G2 2.2.9.22",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "df7b8bd18727765eba73be5ab836e0ee4cfd17b5e680046003b8d608d2fbfda7",
    mainSha256: "776fb77e508955ef7c56cb48945cf96bd30f937c3bb36d916d41e3ebad203a26",
    mainBytes: 3564728,
    version: "2.2.8.4",
    reportedVersion: "2.2.8.4",
    label: "Stock Even Realities G2 2.2.8.4",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "0fced0aebcc6c88db6f76dba34f91b805d842a5fc297bfd7fa6d6a34ec83cecb",
    mainSha256: "8e25fcdadac1efadf8ef97e35086487b673d079f5fd229e56443ac42a5d55c31",
    mainBytes: 3557884,
    version: "2.2.7.14",
    reportedVersion: "2.2.7.14",
    label: "Stock Even Realities G2 2.2.7.14",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "f4dfb0b49ad3de3c2daf17f8a27a157c3dc98411d6a0d3ab2cfd0918f41b9afa",
    mainSha256: "36c5b0e499a68ac2493a497bdab9740fd3e7027730c26a9094eca47268a27863",
    mainBytes: 3523396,
    version: "2.2.6.10",
    reportedVersion: "2.2.6.10",
    label: "Stock Even Realities G2 2.2.6.10",
    hardwareValidated: true,
  }),
  Object.freeze({
    imageSha256: "f9a93621a7141e0ae54ca6371cd2f1b4afbffa61f302ace096e0656ba25b1754",
    mainSha256: "36cf41979ca1f6fbb5357ab728ab1d7daa6f36c1de7d6817f2fcf0b0f6a5090b",
    mainBytes: 3502504,
    version: "2.2.4.34",
    reportedVersion: "2.2.4.34",
    label: "Stock Even Realities G2 2.2.4.34",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "b3b0e213f7eb9568c97603a011b4a0261f9a4dbf9f7c933ff16b25aeb7efe0a6",
    mainSha256: "5497c4cdbb6b8ec83882ff8fab6093ad07ab38f7a317874d06942ca3898a19cf",
    mainBytes: 3367956,
    version: "2.2.0.24",
    reportedVersion: "2.2.0.24",
    label: "Stock Even Realities G2 2.2.0.24",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "75ca2a401f813cf23f864106f4dedbc7e00c4c4b37cd50dcf17f7e9fe503c63e",
    mainSha256: "32cec3ec3d3f76d91704187bf5265636896998bb9f51a79e512917fd690121d1",
    mainBytes: 3306316,
    version: "2.1.1.12",
    reportedVersion: "2.1.1.12",
    label: "Stock Even Realities G2 2.1.1.12",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "1aa72ae9bd4e291866193e80f3f950eb35450d87bd3eab1ed017cb5c3875b3fa",
    mainSha256: "511a82862fadf6f0c0f5609ddb91793143bf3593df14c0aea9023f1dac594f1a",
    mainBytes: 3300560,
    version: "2.1.1.8",
    reportedVersion: "2.1.1.8",
    label: "Stock Even Realities G2 2.1.1.8",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "4b0055531530b3206f7e3acf103e30edeba6c35ed746aba09e52083efb6a2592",
    mainSha256: "2557d7ce9364726e25266d276c0e5400475282cbe5a1c6c93d12cebbf41884f4",
    mainBytes: 3292228,
    version: "2.0.9.20",
    reportedVersion: "2.0.9.20",
    label: "Stock Even Realities G2 2.0.9.20",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "a5e74e6830f4d9f4b8d06e18f11fb7e8f57383e3204504c299c413ce44940c23",
    mainSha256: "2fd4a0317d1fff5e89da8961872efb7fd7436b7778cbfabf7117204d097d5531",
    mainBytes: 3276612,
    version: "2.0.8.20",
    reportedVersion: "2.0.8.20",
    label: "Stock Even Realities G2 2.0.8.20",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "47bdd17b9227d56566280fad42248dbecfe4fc70017ad9c74c3d949e27116b5e",
    mainSha256: "50f48eae3e031885086fa85d5e6f36d3d36582674adf5c6ec1d50da502f029eb",
    mainBytes: 3189184,
    version: "2.0.7.16",
    reportedVersion: "2.0.7.16",
    label: "Stock Even Realities G2 2.0.7.16",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "f3c4c40aa122f61e859b82ee5eaa296ac8fa3a96e7b9905fd8d112ded732c5da",
    mainSha256: "e295640f17a9a6c48734960f003ab663cf34b6835b212afa042db3c5703f5462",
    mainBytes: 3184984,
    version: "2.0.6.14",
    reportedVersion: "2.0.6.14",
    label: "Stock Even Realities G2 2.0.6.14",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "83e3cc196df2d7bd74f735f2ffbfd9f01c204da2cb73a1fb6fee5119f1125e21",
    mainSha256: "dfc0d525940547abb9645d60e1862c8b7e969af0794c851d0b6d1c69c3142c55",
    mainBytes: 3158492,
    version: "2.0.5.12",
    reportedVersion: "2.0.5.12",
    label: "Stock Even Realities G2 2.0.5.12",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "84866f11895c34d15838736a373a50f06765232e2561fedd8ba1b62ba509c09c",
    mainSha256: "5cd7785bb232c298d66c0655c1236c8b8924419bdd61b9b35cf0ff04bd18ff4c",
    mainBytes: 3069108,
    version: "2.0.3.20",
    reportedVersion: "2.0.3.20",
    label: "Stock Even Realities G2 2.0.3.20",
    hardwareValidated: false,
  }),
  Object.freeze({
    imageSha256: "d45005d5f75985339b234550b384899bb89fb37cfe4de4928abc9e882f0709e2",
    mainSha256: "ad951aec8e4140392c12715d2d1f8d575c8e288ab35331a635e2277cfb2b56fc",
    mainBytes: 2471336,
    version: "2.0.1.14",
    reportedVersion: "2.0.1.14",
    label: "Stock Even Realities G2 2.0.1.14",
    hardwareValidated: false,
  }),
]);

export function findTempleFlashTarget(imageSha256) {
  if (typeof imageSha256 !== "string") return null;
  const digest = imageSha256.toLowerCase();
  return TEMPLE_FLASH_TARGETS.find((t) => t.imageSha256 === digest) ?? null;
}
